import { TextField, Button, Container, Stack, Backdrop, CircularProgress } from "@mui/material";
import { useContext, useRef, useState, useEffect } from "react";
import { MsgContext } from "../../App";
import dayjs from 'dayjs';
import axios from "axios";
import { API, MSG } from "./constantsFront";
import parse from 'html-react-parser';

const G02012RacUpload = () => {
  const [standardDate, setStandardDate] = useState(""); // 基準日
  const [registerStandardDate, setRegisterStandardDate] = useState(""); // 登録済基準日
  const [errorStandardDate, setErrorStandardDate] = useState(""); // 基準日エラー
  const { msg, setMsg } = useContext(MsgContext); // エラーメッセージ
  const [isLoading, setIsLoading] = useState(false);  // Loading
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFlag, setSelectedFlag] = useState(false);
  const [fileMsg, setFileMsg] = useState(""); // ファイルメッセージ
  const fileInputRef = useRef(null);

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  // 必須ファイル名
  const itemCommon = "品目共通項目.csv";
  const countryProductNameCsv = "各国資料等で検索する場合の品目名.csv";
  const specimenCsv = "検体.csv";
  const remarksCsv = "備考.csv";
  const standardValue = "基準値一覧.csv";
  const pesticide = "農薬一覧.csv";

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    // ファイルメッセージの作成
    getFileMsg();

    displayData();

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;

  }, [])

  // 表示データ用
  function displayData() {
    // Loading
    setIsLoading(true);
    // 登録済基準日取得
    let body = { authKey: API.API_KEY };
    axios.post("/m_rac_country_product_name/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      // 日付をフォーマット
      let dataList = res.data.dataList
      for (let i in dataList) {
        if (i == 1) {
          break;
        }
        setRegisterStandardDate(dayjs(dataList[i].update_date).format("YYYY年MM月DD日"));
      }

    }).catch(error => {
      console.log('error:', error);
      setMsg(MSG.EXCEPTION);
    }).finally(() => {
      // Loading
      setIsLoading(false);
    });
  }

  // ファイル選択時
  const handleFileChange = (event) => {
    setSelectedFiles(event.target.files);

    let errMsg = null;
    // ファイル数チェック
    if (event.target.files.length !== 6) {
      errMsg = "必要なファイル数は6個です。";
      setMsg(errMsg);
    }

    let fileArr = getFileMsg(event.target.files);

    // 正常か確認
    if (errMsg !== null || fileArr.length !== 0) {
      setSelectedFlag(false);
      return;
    }
    setSelectedFlag(true);
  };

  // ファイル選択ボタン
  const handleButtonClick = () => {
    // ファイル選択ダイアログを開く
    fileInputRef.current.value = null;
    fileInputRef.current.click();
  };

  // アップロード処理
  const handleUpload = async () => {
    try {
      // Loading
      setIsLoading(true);

      if (!standardDate) {
        setErrorStandardDate("基準日は必須です。");
        return;
      } else {
        setErrorStandardDate("");
      }

      const formData = new FormData();
      for (let i = 0; i < selectedFiles.length; i++) {
        // ファイル名をUTF-8にエンコードしてから、ファイルを追加
        const encodedFileName = encodeURIComponent(selectedFiles[i].name);
        formData.append('files', selectedFiles[i], encodedFileName);
      }

      formData.append('standardDate', standardDate);

      await axios.post("/m_rac_upload/upload/auth", formData)
        .then(async (res) => {
          await insertNews();
          displayData();
          setSelectedFiles([]);
          setSelectedFlag(false);
          getFileMsg();
          alert("アップロードに成功しました。");
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            setMsg(error.response.data);
          } else {
            throw new Error("uploadエラー");
          }
        });

    } catch (e) {
      console.log(e.message);
      setMsg(MSG.EXCEPTION);
    } finally {
      setIsLoading(false);
    }
  };

  // ファイルメッセージの作成
  function getFileMsg(files = []){
    let fileMsg = '<p>以下のファイルを選択してください。</p>';
    let fileArr = [itemCommon, countryProductNameCsv, specimenCsv, remarksCsv, standardValue, pesticide];
    for (let i = 0; i < files.length; i++) {
      fileArr = fileArr.filter(item => item !== files[i].name);
    }

    if (fileArr.length !== 0) {
      fileMsg += '<p style="color: red">' + fileArr.join('<br />') + '</p>';
      setFileMsg(fileMsg);
    } else {
      setFileMsg("");
    }
    return fileArr;
  }

  // 更新履歴登録処理
  async function insertNews() {
    let body = { authKey: API.API_KEY };
    let title = "残留農薬データについて、" + dayjs(standardDate).format('YYYY/MM/DD') + " 基準日のデータを反映しました。";

    body.title = title;
    const res = await axios.post("/m_news/select/auth", body);
    if (res.data.newsList.length !== 0) {
      return;
    }

    var csletr = [];
    var arrStr = [];

    const res1 = await axios.post("/m_news/select/maxnewsid/auth", body);
    // データが取得できた時の処理
    let maxid = null;
    let maxnewsid = res1.data.maxnews;

    // newsidの最大値が0以上の場合は+1する
    if (maxnewsid[0].id != null && maxnewsid[0].id >= 0) {
      maxid = maxnewsid[0].id + 1;
    } else {
      maxid = 0;
    }

    csletr.push(maxid); // 0（ID）
    csletr.push(dayjs(new Date()).format('YYYY/MM/DD')); // 1（公開日時）
    csletr.push(title); // 2（タイトル）
    csletr.push(""); // 3（内容）

    arrStr = JSON.stringify(csletr);
    body.arrStr = arrStr;

    const res2 = await axios.post("/m_news/insert/auth", body);
    if (res2.status === 200) {
      console.log('insert成功');
    } else {
      console.log('insert失敗');
    }
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg">
                {/* Loading */}
                <Backdrop open={isLoading}
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                  <CircularProgress />
                </Backdrop>

                <Stack spacing={2} >
                  <h1>残留農薬　一括登録</h1>

                  <Button href="./G0201Rac"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    戻る
                  </Button>

                  <div><p>登録済基準日:{registerStandardDate}</p></div>

                  <TextField required id="standardDate"
                    value={standardDate ?? ''}
                    label="基準日"
                    type={"date"}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    helperText={errorStandardDate}
                    error={Boolean(errorStandardDate == "" ? false : true)}
                    onChange={e => { setStandardDate(e.target.value) }}
                  />

                  <input
                    type="file"
                    multiple
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                  <Stack spacing={2} direction="row">
                    <Button onClick={handleButtonClick}
                      style={{
                        width: "200px"
                        , color: "white"
                        , textDecoration: "none"
                      }}>
                      ファイル選択
                    </Button>

                    {selectedFlag === true ? (
                      <>
                        <Button onClick={handleUpload}
                          style={{
                            width: "200px"
                            , color: "white"
                            , textDecoration: "none"
                          }}>
                          登録
                        </Button>
                      </>
                    ) : (
                      <>
                        <p>選択されたファイル数: {selectedFiles.length}</p>
                      </>
                    )}
                  </Stack>
                  <div>{parse(fileMsg)}</div>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default G02012RacUpload;